import { MessageType } from "./constants";

export const getMessageTypeLabel = (resources, messageType) => {
	switch (messageType) {
		case MessageType.email:
			return resources["EmailMessage"];
		case MessageType.sms:
			return resources["SMSMessage"];
		case MessageType.chatMessage:
			return resources["ChatMessage"];
		default:
			return resources["EmailMessage"];
	}
};
